import React, {useState} from "react";
import Table from "../../../../../app/components/Table";
import Input from "../../../../../app/components/Input";


const Financial = () => {

    const columnsFinancial = [
        { campo: 'numero', titulo: 'Número' },
        { campo: 'faturado_em', titulo: 'Faturado em' },
        { campo: 'vencimento', titulo: 'Vencimento' },
        { campo: 'metodo', titulo: 'Método' },
        { campo: 'status', titulo: 'Status' },
        { campo: 'total', titulo: 'Total' },
        { campo: 'acoes', titulo: 'Ações' }
    ];
    
    const [dataFinancial, setDataFinancial] = useState([
    ]);
    

    return(
        <div>
            <div className="flex justify-between items-center mb-8 pt-4">
                    <h2 class="text-lg font-medium text-gray-900">Informações financeiras</h2>
                    <span className="bg-[#3f1057] rounded-tr-2xl rounded-tl-2xl rounded-br-2xl text-xs py-1 px-2 text-white font-semibold">Não definido</span>
            </div>
            <div className="border rounded-tr-2xl rounded-tl-2xl rounded-br-2xl p-4">
                <div>
                    <div className="flex justify-between items-center font-semibold text-gray-400">
                        <span className="text-xs">Plano atual</span>
                        <span className="text-sm">SMB - Pequenas Empresas</span>
                    </div>
                    <div className="flex items-center mt-6 text-[#3f1057]">
                        <h3 className="text-3xl font-semibold">R$750,00</h3>
                        <span className="font-semibold text-sm">/mês</span>
                    </div>
                    <p className="text-sm text-gray-800 font-medium mt-1">10 usuário(s) x R$75,00 = R$750,00</p>
                    <div className="mt-6 rounded-tr-2xl rounded-tl-2xl rounded-br-2xl text-gray-400">
                        <p className="font-semibold">Seu plano renova em 15 de agosto de 2025, com um total de R$ 750,00</p>
                        <span className="text-sm font-medium">Próxima cobrança: 14/07/2025</span>
                    </div>
                </div>
            </div>
            <div>
                <div className="flex items-center mt-16 justify-between mb-4">
                    <h2 class="text-lg font-medium text-gray-900">Faturas</h2>
                    <Input
                        type="text"
                        size="xs"
                        variant="search"
                        label="Pesquisar"
                    />
                </div>
                {dataFinancial.length === 0 ? (
                    <div className="text-center text-sm text-gray-500 py-8 font-medium">
                        Nenhuma fatura encontrada.
                    </div>
                ) : (
                    <Table
                        colunas={columnsFinancial}
                        dados={dataFinancial}
                    />
                )}
            </div>
        </div>
    )
}

export default Financial